module.exports = __webpack_public_path__ + "static/media/clone.18168fc6.svg";